import type { CoachOption } from "./types.ts";

/**
 * Returns the set of contact-order (ordinal) values shared by more than one advisor
 * within a single student group. Advisors without a numeric ordinal are ignored.
 */
export const getConflictingOrdinals = (advisors: CoachOption[]): Set<number> => {
  const counts = new Map<number, number>();
  for (const advisor of advisors) {
    if (typeof advisor.ordinal === "number") {
      counts.set(advisor.ordinal, (counts.get(advisor.ordinal) ?? 0) + 1);
    }
  }

  const conflicts = new Set<number>();
  for (const [ordinal, count] of counts) {
    if (count > 1) {
      conflicts.add(ordinal);
    }
  }
  return conflicts;
};
